import { css } from '@emotion/react';

import { breakpoints } from '@coursera/cds-common';

import { getPaletteColor } from './colors';
import type { DialogColor, DialogVariant } from './types';

const variants = {
  standard: css`
    padding-top: var(--cds-spacing-300);
    padding-inline-end: var(--cds-spacing-300);
  `,

  transactional: css`
    padding: 0;
  `,

  sticky: css`
    position: sticky;
    top: 0;
  `,
};

export const getCloseCss = ({
  color,
  variant,
  sticky,
}: {
  color: DialogColor;
  variant: DialogVariant;
  sticky: boolean;
}) => {
  return css`
    grid-area: close;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-start;
    background-color: ${getPaletteColor(color)};
    z-index: 1;

    ${breakpoints.down('xs')} {
      border-radius: 0;
    }

    ${variants[variant]}

    ${sticky && variants.sticky}
  `;
};
